import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { isVideoFile, isPdfFile, isImageFile, getFileNameFromPath } from './mediaFileUtils';

const MediaFilePreview = ({
    filePath,
    alt = '',
    className,
    imageClassName = 'media-image',
    style,
    compact = false,
    asCardImg = true,
    allowEmbedFallback = false,
    videoProps = {},
    onClick,
}) => {
    if (!filePath) return null;

    if (isPdfFile(filePath)) {
        const fileName = getFileNameFromPath(filePath);
        return (
            <div
                className={`media-pdf-placeholder${compact ? ' media-pdf-placeholder--compact' : ''}${className ? ` ${className}` : ''}`}
                style={style}
                onClick={onClick}
            >
                <FontAwesomeIcon
                    icon={faFilePdf}
                    className={compact ? 'media-pdf-icon-compact' : 'media-pdf-icon'}
                />
                {!compact && <span className="media-pdf-filename">{fileName}</span>}
            </div>
        );
    }

    if (isVideoFile(filePath)) {
        return (
            <video
                src={filePath}
                className={imageClassName}
                style={style}
                onClick={onClick}
                {...videoProps}
            />
        );
    }

    if (isImageFile(filePath) || !allowEmbedFallback) {
        if (asCardImg) {
            return (
                <Card.Img
                    variant="top"
                    src={filePath}
                    alt={alt}
                    className={imageClassName}
                    style={style}
                    loading="lazy"
                    onClick={onClick}
                />
            );
        }

        return (
            <img
                src={filePath}
                alt={alt}
                className={imageClassName}
                style={style}
                loading="lazy"
                onClick={onClick}
            />
        );
    }

    return (
        <iframe
            src={filePath}
            className={imageClassName}
            style={style}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            title={alt}
        />
    );
};

export default MediaFilePreview;
